"use strict";

exports.__esModule = true;
exports.TEXT_ALIGNMENT_DEFAULT_HOMEPAGE = exports.TEXT_ALIGNMENT_DEFAULT_CATEGORY = exports.TEXT_ALIGNMENT_CLASS_NAMES = exports.TEXT_ALIGNMENT_RIGHT = exports.TEXT_ALIGNMENT_CENTER = exports.TEXT_ALIGNMENT_LEFT = void 0;

var _TEXT_ALIGNMENT_CLASS;

var TEXT_ALIGNMENT_LEFT = 0;
exports.TEXT_ALIGNMENT_LEFT = TEXT_ALIGNMENT_LEFT;
var TEXT_ALIGNMENT_CENTER = 1;
exports.TEXT_ALIGNMENT_CENTER = TEXT_ALIGNMENT_CENTER;
var TEXT_ALIGNMENT_RIGHT = 2;
exports.TEXT_ALIGNMENT_RIGHT = TEXT_ALIGNMENT_RIGHT;
var TEXT_ALIGNMENT_CLASS_NAMES = (_TEXT_ALIGNMENT_CLASS = {}, _TEXT_ALIGNMENT_CLASS[TEXT_ALIGNMENT_LEFT] = 'left', _TEXT_ALIGNMENT_CLASS[TEXT_ALIGNMENT_CENTER] = 'center', _TEXT_ALIGNMENT_CLASS[TEXT_ALIGNMENT_RIGHT] = 'right', _TEXT_ALIGNMENT_CLASS);
exports.TEXT_ALIGNMENT_CLASS_NAMES = TEXT_ALIGNMENT_CLASS_NAMES;
var TEXT_ALIGNMENT_DEFAULT_CATEGORY = TEXT_ALIGNMENT_LEFT;
exports.TEXT_ALIGNMENT_DEFAULT_CATEGORY = TEXT_ALIGNMENT_DEFAULT_CATEGORY;
var TEXT_ALIGNMENT_DEFAULT_HOMEPAGE = TEXT_ALIGNMENT_CENTER;
exports.TEXT_ALIGNMENT_DEFAULT_HOMEPAGE = TEXT_ALIGNMENT_DEFAULT_HOMEPAGE;